import * as colors from './colors'

const rawStyles = {
    active: {
        '&:before': {
            content: '"\\F0D7"',
            color: '#78b706',
            fontFamily: 'FontAwesome',
            fontSize: '18px',
            position: 'absolute',
            width: '10px',
            top: '-6px',
            left: '50%',
            marginLeft: '-5px',
        },
        borderTop: '3px solid #78b706',
    },
    breadcrumb: {
        cursor: 'pointer',
        display: 'flex',
        height: '44px',
    },
    breadcrumbHeader: {
        backgroundColor: colors.secondaryOne,
        color: 'white',
        width: '100%',
    },
    breadcrumbs: {
        alignSelf: 'flex-start',
        display: 'flex',
        height: '44px',
        margin: '0',
        gridColumnEnd: 'breadcrumbOverflow',
        gridColumnStart: 'controlBar',
        gridRowStart: 'subHeader',
        zIndex: '402',
    },
    breadcrumbTriangle: {
        height: '100%',
        position: 'absolute',
        overflow: 'visible',
        width: '90%',
    },
    breadcrumbTriangleCtr: {
        backgroundColor: 'transparent',
        flexShrink: '0',
        overflow: 'hidden',
        position: 'relative',
        width: '18px',
        height: '44px',
    },
    breadcrumbTriangleFill: {
        fill: colors.secondaryOne,
    },
    headerTextContent: {
        alignItems: 'center',
        backgroundColor: 'transparent',
        color: 'textColor',
        display: 'flex',
        fontSize: '1.35em',
        margin: '10px',
    },
    item: {
        borderTop: `3px solid ${colors.secondaryOne}`,
        lineHeight: '18px',
        position: 'relative',
    },
    itemTextContent: {
        fontSize: '14px',
        height: '21px',
        lineHeight: '21px',
        margin: '10px',
    },
}

export default rawStyles
